import { getCoreRowModel, getSortedRowModel, SortingState, useReactTable } from '@tanstack/react-table'
import React, { useState } from 'react'
import TanStackTable from '../../../../../components/tables/TanStackTable'
import tableData from './fleetReportDetailsData'

const columns = tableData()

type FleetReportDetailsProps = {
  data: any
  isLoading?: boolean
}
function FleetReportDetailsTable({ data, isLoading }: FleetReportDetailsProps) {
  const [sorting, setSorting] = useState<SortingState>([])

  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  return <TanStackTable table={table} isLoading={isLoading} />
}

export default FleetReportDetailsTable
